<div class="login-wrapper">
    <div class="container-common">
        <div class="row justify-content-center">
            <div class="col-md-6">
                <div class="d-flex align-items-center minheight70vh">
                    <form class="login_box_outer w-100" [formGroup]="loginForm">
                        <div class="login-box max-WT-520">
                            <div class="login-right-block">
                                <div class="login-heading">
                                    <h4>LOGIN</h4>
                                </div>
                                <div class="login-box-body">
                                    <div class="form-group mb-3">
                                        <input type="text" formControlName="email" class="form-control" maxlength="50"
                                            placeholder="Email ID" (keypress)="mainService.preventSpace($event)" />

                                        @if(loginForm.get('email')?.invalid && (loginForm.get('email')?.dirty ||
                                        loginForm.get('email')?.touched)){
                                        <div class="text-danger" style="color: red;text-align: start">
                                            @if(loginForm.get('email')?.hasError('required')){
                                            <small>
                                                *Email address is required.
                                            </small>
                                            }
                                            @if(loginForm.get('email')?.hasError('pattern')){
                                            <small>
                                                *Please enter valid email.
                                            </small>
                                            }
                                        </div>
                                        }
                                    </div>
                                    <div class="form-group mb-3 eyeicon">
                                        <input type="password" maxlength="18" formControlName="password"
                                            class="form-control " placeholder="Password"
                                            (keypress)="mainService.preventSpace($event)" />

                                        @if(loginForm.get('password')?.invalid && (loginForm.get('password')?.dirty ||
                                        loginForm.get('password')?.touched)){
                                        <div class="text-danger" style="color: red;text-align: start">
                                            @if(loginForm.get('password')?.hasError('required')){
                                            <small>
                                                *Password is required.
                                            </small>}
                                        </div>
                                        }
                                    </div>
                                    <div class="d-flex justify-content-between align-items-center mb-3">
                                        <label class="checkbox-design">
                                            <input type="checkbox" formControlName="rememberMe" />
                                            <span></span>
                                            Remember me
                                        </label>
                                        <span class="ms-auto forgot-links">
                                            <a [routerLink]="['/forgot-password']" class="link font17">
                                                Forgot Password?
                                            </a>
                                        </span>
                                    </div>

                                </div>
                                <div class="text-center">
                                    <button class="btn btn-theme btn-large width100 font-100"
                                        [disabled]="!loginForm.valid" (click)="login()">LOGIN</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>